import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksRecomendedCounterparties(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES].getRegulationsStagesPlanWorksRecomendedCounterparties,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}

export default {
	getRegulationsStagesPlanWorksRecomendedCounterparties,
}
